<ui-loader class="loader" *ngIf="loading"></ui-loader>

<div [class.loading]="loading">
  <div class="header label-sm-semibold">
    {{ 'signals-ng-visualization-tab.visualizationViews.pocTopicClusters' | translate | titleCase }}
  </div>
  <div class="metric-switch" *ifFeature="'insights.app.experimental-relevance-scores'">
    <span class="title-sm"
      >{{ 'signals-ng-visualization-tab.visualizationViews.topicClusterMetricFilterTitle' | translate | titleCase }}:
    </span>
    <ng-select
      class="ui2-dropdown inline-dropdown"
      [clearable]="false"
      bindValue="value"
      [items]="metricOptions"
      [(ngModel)]="metricSwitch"
      (ngModelChange)="onSwitchChange($event)"
    >
      <ng-template ng-label-tmp let-item="item">
        <div>
          <span>{{ item.label | translate }}</span>
        </div>
      </ng-template>
      <ng-template ng-option-tmp let-item="item">
        <div class="option">
          <span>{{ item.label | translate }}</span>
        </div>
      </ng-template>
    </ng-select>
  </div>

  <ui-range-picker
    *ngIf="sliderConfig && !noData"
    class="ui-range-picker no-floorCeil-label"
    [value]="sliderConfig.minValue"
    [maxValue]="sliderConfig.maxValue"
    [options]="sliderConfig.options"
    (onChange)="constrainData($event)"
  >
  </ui-range-picker>

  <chart-circle-packing-canvas
    class="circle-packing-canvas"
    [disableSelection]="false"
    [disableRemove]="true"
    [noData]="noData"
    [data]="filteredData"
    [(selectModel)]="model"
    [modelProperty]="'label'"
    [categoryKey]="insightsType.TOPICS"
    (selectModelChange)="select($event)"
    (trackEvent)="trackEvent($event)"
    (remove)="trackEvent(TrackedActions.VALUE_DESELECTED)"
  ></chart-circle-packing-canvas>
</div>
